module.exports = __webpack_public_path__ + "img/icon_wjh.cc0e2a21.png";